import { COLLECTIONS } from "constants/action-types";
import { IPackInfo } from "reducers/collection";

export const fetchSizePacks = (brand: string, includeNormalized = true, lastFetchedId?: string) => {
    return {
        payload: {
            brand,
            includeNormalized,
            lastFetchedId,
        },
        type: COLLECTIONS.COLLECTION.SIZE_PACKS.FETCH.START,
    };
};

export const sizePacksFetchComplete = (
    newSizePacks?: { [key: string]: { [key1: string]: IPackInfo } },
    error: boolean = false,
) => {
    return {
        payload: {
            newSizePacks,
            error,
        },
        type: COLLECTIONS.COLLECTION.SIZE_PACKS.FETCH.COMPLETED,
    };
};
